/* op.js — Eastlight one-product PDP. Vanilla, deferred, one file. Budget ≤8 KB.
   Adds: add-to-cart (fetch + drawer), sticky ATC, tier selector price sync, FAQ exclusive-open
   polyfill, review-slot skeleton removal, quantity buttons. Content never depends on this file:
   with JS off the form POSTs natively to /cart/add and the page still sells. (INTEGRATION §D, §F) */
(function () {
  'use strict';
  window.OP = window.OP || {};
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var root = function () { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; };

  /* ---------- Cart helpers ---------- */
  window.OP.renderCartSections = function (sections) {
    Object.keys(sections || {}).forEach(function (id) {
      var html = sections[id];
      if (!html) return;
      var target = document.getElementById('shopify-section-' + id);
      if (!target) return;
      var incoming = new DOMParser().parseFromString(html, 'text/html').getElementById('shopify-section-' + id);
      if (incoming) target.innerHTML = incoming.innerHTML;
    });
  };
  window.OP.openCart = function () {
    // 1. Documented storefront action (2026+). 2. Dawn's <cart-drawer>.open() (version-sensitive). 3. /cart always works.
    if (window.Shopify && window.Shopify.actions && typeof window.Shopify.actions.openCart === 'function') { window.Shopify.actions.openCart(); return; }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
    window.location.href = root() + 'cart';
  };

  /* ---------- Add to cart: the ONE product form ---------- */
  (function () {
    var form = document.querySelector('[data-op-product-form]');
    if (!form) return;
    var errorEl = form.querySelector('[data-op-form-error]');
    function buttons() { return $$('button[form="' + form.id + '"], [data-op-product-form] button[type="submit"]'); }
    function setBusy(on) {
      buttons().forEach(function (b) {
        if (on) { b.dataset.opWasDisabled = b.disabled ? '1' : ''; b.disabled = true; }
        else if (!b.dataset.opWasDisabled) { b.disabled = false; }
        b.classList.toggle('op-btn--busy', on);
        b.setAttribute('aria-busy', on ? 'true' : 'false');
      });
    }
    function showError(msg) { if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; } }
    function clearError() { if (errorEl) { errorEl.textContent = ''; errorEl.hidden = true; } }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearError();
      // FormData reads form.elements, which includes the tier radios bound by the `form` attribute.
      var data = new FormData(form);
      if (!data.get('id')) { showError('Choose a quantity option first.'); return; }
      setBusy(true);
      data.append('sections', 'cart-drawer,cart-icon-bubble');
      fetch(root() + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/javascript' }, body: data })
        .then(function (res) { return res.json().then(function (j) { return { ok: res.ok, json: j }; }); })
        .then(function (r) {
          if (!r.ok) { showError((r.json && (r.json.description || r.json.message)) || 'Something went wrong. Please try again.'); return; }
          if (r.json.sections) window.OP.renderCartSections(r.json.sections);
          document.dispatchEvent(new CustomEvent('op:cart:added', { detail: r.json }));
          window.OP.openCart();
        })
        .catch(function () {
          showError('We could not reach the cart. Taking you there now…');
          window.setTimeout(function () { form.submit(); }, 600);
        })
        .then(function () { setBusy(false); });
    });
    // Quantity stepper (only when the hero enables it)
    document.addEventListener('click', function (e) {
      var up = e.target.closest('[data-op-qty-up]'), down = e.target.closest('[data-op-qty-down]');
      if (!up && !down) return;
      var input = form.querySelector('[data-op-qty-input]');
      if (!input) return;
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, v + (up ? 1 : -1));
    });
  })();

  /* ---------- Tier selector: radios ARE the variant input; this is presentation only ---------- */
  (function () {
    function apply(input) {
      var d = input.dataset;
      $$('[data-op-price-current], [data-op-sticky-price]').forEach(function (el) { el.textContent = d.opPrice || ''; });
      $$('[data-op-price-compare], [data-op-sticky-compare]').forEach(function (el) { el.textContent = d.opCompare || ''; el.hidden = !d.opCompare; });
      $$('[data-op-price-save]').forEach(function (el) { el.textContent = d.opSave || ''; el.hidden = !d.opSave; });
      $$('[data-op-cta-price]').forEach(function (el) { el.textContent = d.opPrice ? ' — ' + d.opPrice : ''; });
      $$('[data-op-sticky-variant]').forEach(function (el) { el.textContent = d.opTitle || ''; });
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', input.value);
        window.history.replaceState({}, '', url);
      } catch (e) {}
      document.dispatchEvent(new CustomEvent('op:variant:change', { detail: { id: input.value, price: d.opPrice, title: d.opTitle } }));
    }
    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-op-tier]');
      if (input && input.checked) apply(input);
    });
    // Sync once on load in case the browser restored a non-default radio (back/forward cache).
    var checked = document.querySelector('[data-op-tier]:checked');
    if (checked && checked !== document.querySelector('[data-op-tier]')) apply(checked);
  })();

  /* ---------- Sticky ATC: sentinel-driven, never a pixel depth ---------- */
  (function () {
    var bar = document.querySelector('[data-op-sticky]');
    var sentinel = document.querySelector('[data-op-atc-sentinel]');
    var footer = document.querySelector('.footer, footer');
    var form = document.querySelector('[data-op-product-form]');
    if (!bar || !form || !sentinel) return;
    var st = { pastHero: false, footerVisible: false, drawerOpen: false, typing: false };
    var cta = bar.querySelector('[data-op-sticky-cta]');
    function apply() {
      var show = st.pastHero && !st.footerVisible && !st.drawerOpen && !st.typing;
      bar.hidden = false;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (cta) cta.tabIndex = show ? 0 : -1;
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        // Past the hero = sentinel above the viewport (not merely off-screen below on first paint).
        var e = en[0];
        st.pastHero = !e.isIntersecting && e.boundingClientRect.top < 0;
        apply();
      }, { threshold: 0 }).observe(sentinel);
      if (footer) new IntersectionObserver(function (en) { st.footerVisible = en[0].isIntersecting; apply(); }, { threshold: 0 }).observe(footer);
    }
    document.addEventListener('focusin', function (e) {
      var t = e.target;
      st.typing = !!(t && t.matches && t.matches('input:not([type=hidden]):not([type=radio]):not([type=checkbox]), textarea, select'));
      apply();
    }, { passive: true });
    document.addEventListener('focusout', function () { st.typing = false; apply(); }, { passive: true });
    new MutationObserver(function () {
      var open = document.body.classList.contains('overflow-hidden') || !!document.querySelector('cart-drawer.active, dialog[open], [data-op-modal-open]');
      if (open !== st.drawerOpen) { st.drawerOpen = open; apply(); }
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    document.addEventListener('op:cart:added', function () { st.drawerOpen = true; apply(); });
    apply();
  })();

  /* ---------- FAQ: exclusive-open polyfill for browsers without <details name> ---------- */
  (function () {
    var supportsName = 'name' in document.createElement('details');
    if (supportsName) return;
    document.addEventListener('toggle', function (e) {
      var d = e.target;
      if (!d.matches || !d.matches('.op-faq__item') || !d.open) return;
      var list = d.closest('[data-op-faq]');
      if (!list) return;
      $$('.op-faq__item[open]', list).forEach(function (o) { if (o !== d) o.open = false; });
    }, true);
  })();

  /* ---------- Review-widget skeleton: remove on mount, never on a timer ---------- */
  (function () {
    var slot = document.querySelector('[data-op-reviews-slot]');
    var skel = document.querySelector('[data-op-reviews-skeleton]');
    if (!slot || !skel) return;
    var box = skel.parentNode;
    function mounted() { return !!box.querySelector(':scope > *:not([data-op-reviews-skeleton]) > *'); }
    if (mounted()) { skel.remove(); return; }
    var obs = new MutationObserver(function () { if (mounted()) { skel.remove(); obs.disconnect(); } });
    obs.observe(box, { childList: true, subtree: true });
  })();

  /* Theme editor: sections re-render on every setting change; re-run tier sync for the new DOM. */
  document.addEventListener('shopify:section:load', function () {
    var checked = document.querySelector('[data-op-tier]:checked');
    if (checked) checked.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();
